"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Tooltip_meta_1 = require("../Tooltip.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var shared_1 = require("../../../../shared");

var pathStyle = {
  fill: 'inherit',
  stroke: 'inherit',
  strokeWidth: '1px',
  strokeDasharray: '14,7,0'
};

var arrow = function arrow() {
  return react_1.default.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, react_1.default.createElement("path", {
    className: "arrow__path",
    d: "M7,10L12,15L17,10H7Z",
    style: pathStyle
  }));
};

var ArrowIcon = function ArrowIcon(props) {
  var className = props.className,
      _a = props.children,
      children = _a === void 0 ? '' : _a,
      sectionProps = __rest(props, ["className", "children"]);

  var Section = shared_1.withSelector('section', props);
  return react_1.default.createElement(Section, __assign({
    className: className
  }, sectionProps), arrow());
};

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(ArrowIcon, Tooltip_meta_1.TOOLTIP_CATEGORY_KEY, Tooltip_meta_1.TOOLTIP_COMPONENT_KEY, ['arrowIcon']);